import React from 'react';
import { Box } from '@landr/maestro';
import { classNames } from 'react-extras';
import { DynamicIcon } from './components';

export interface IconBadgeProps {
    icon: string;
    color?: string;
    background?: string;
}

const getBackgroundColorWithOpacity = (background?: string) => {
    if (!background) {
        return;
    }
    if (background.startsWith('#')) {
        const hex = background.replace('#', '');
        const r = parseInt(hex.slice(0, 2), 16);
        const g = parseInt(hex.slice(2, 4), 16);
        const b = parseInt(hex.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, 0.32)`;
    }
    return background;
};

export const IconBadge = (props: IconBadgeProps) => {
    const { icon, color, background } = props;

    const badgeClass = classNames('IconBadge');

    return (
        <Box
            className={badgeClass}
            style={{
                color: color,
                backgroundColor: getBackgroundColorWithOpacity(background),
                height: 36,
                width: 36,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
            }}
        >
            <DynamicIcon iconName={icon} />
        </Box>
    );
};
